import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import styles from './PremiumPage.module.css';
import { MdCheckCircle } from 'react-icons/md';

const PremiumPage: React.FC = () => {
  const { currentUser, userProfile, isLoggedIn, isPremium, updateUserProfileData } = useAuth();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);
  const navigate = useNavigate();

  const handlePremiumSubscription = async () => {
    if (!currentUser || !updateUserProfileData) return;

    setLoading(true);

    try {
      await updateUserProfileData(currentUser.uid, {
        isPremium: true,
        premiumSince: new Date().toISOString()
      });

      setSuccess(true);
    } catch (err: any) {
      setError(err.message || 'Premium hesaba yükseltilirken bir hata oluştu.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.premiumPage}>
      <div className={styles.heroSection}>
        <div className={styles.heroContent}>
            <img 
            src="/public/logo-white-premium.png" 
            alt="vagonla premium" 
            className={styles.premiumLogo} 
            style={{ width: '300px', height: 'auto' }}
            />
          <p className={styles.subtitle}>
            Toplu taşıma deneyiminizi bir üst seviyeye taşıyın
          </p>
          
          {isPremium ? (
            <div className={styles.alreadyPremiumCard}>
              <MdCheckCircle className={styles.checkIcon} />
              <h2>Premium Üyeliğiniz Aktif</h2>
              <p>
          Tebrikler! Premium özelliklerin keyfini çıkarabilirsiniz. Herhangi bir sorunla karşılaşırsanız, lütfen bizimle iletişime geçin.
              </p>
              <button 
          className={styles.backToProfileButton}
          onClick={() => navigate('/profile')}
              >
          Profilime Dön
              </button>
            </div>
          ) : (
            <div className={styles.upgradeSection}>
              <div className={styles.specialOffer}>
          <span className={styles.offerTag}>SINIRLI SÜRE TEKLİFİ</span>
          <h2>Şimdi Ücretsiz Premium Olun!</h2>
          <p>
            Uygulamamız yeni olduğu için, sınırlı bir süre için premium özellikleri 
            <strong> tamamen ücretsiz</strong> sunuyoruz. Bu fırsatı kaçırmayın!
          </p>
              </div>
              
              {error && (
          <div className={styles.errorMessage}>{error}</div>
              )}
              
              {success ? (
          <div className={styles.successMessage}>
            <MdCheckCircle className={styles.successIcon} />
            <h3>Premium Hesaba Yükseltildi!</h3>
            <p>Tebrikler! Artık premium özelliklerin keyfini çıkarabilirsiniz.</p>
            <button 
              className={styles.backToProfileButton}
              onClick={() => navigate('/profile')}
            >
              Profilime Dön
            </button>
          </div>
              ) : (
          <button 
            className={styles.upgradeButton}
            onClick={handlePremiumSubscription}
            disabled={loading || !isLoggedIn}
          >
            {loading ? 'Yükseltiliyor...' : isLoggedIn ? 'Ücretsiz Premium Olun' : 'Giriş Yapın'}
          </button>
              )}
              
              {!isLoggedIn && (
          <p className={styles.loginPrompt}>
            Premium özellikleri kullanmak için lütfen <a href="/login">giriş yapın</a> veya <a href="/register">kayıt olun</a>.
          </p>
              )}
            </div>
          )}
        </div>
      </div>
      
      <div className={styles.callToAction}>
        <h2>Daha İyi Bir Toplu Taşıma Deneyimi İçin</h2>
        <p>Premium özelliklerle yolculuklarınızı daha kolay ve keyifli hale getirin.</p>
        
        {!userProfile?.isPremium && !success && (
          <button 
            className={styles.upgradeButtonAlt}
            onClick={handlePremiumSubscription}
            disabled={loading || !isLoggedIn}
          >
            {loading ? 'Yükseltiliyor...' : 'Hemen Premium Olun'}
          </button>
        )}
      </div>
    </div>
  );
};

export default PremiumPage;
